<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '../stores/auth'
import { useI18n } from 'vue-i18n'

const authStore = useAuthStore()
const { t } = useI18n()

// Get user email
const userEmail = computed(() => authStore.user?.email || '')
</script>

<template>
  <main class="bg-gray-50 min-h-screen flex items-center justify-center px-4 py-8">
    <div class="w-full max-w-6xl">
      <!-- Page Header -->
      <div class="text-center mb-8">
        <h1 class="text-2xl font-bold text-gray-900">{{ t('chooseProfile.title') }}</h1>
        <p class="text-sm text-gray-600 mt-2">{{ t('chooseProfile.subtitle') }}</p>
      </div>

      <!-- Two Column Layout -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Left Side: Player/Parent -->
        <div class="bg-white border-2 border-gray-300 rounded shadow-md p-6">
          <h2 class="text-xl font-semibold text-gray-800 mb-3">{{ t('chooseProfile.playerTitle') }}</h2>
          <p class="text-sm text-gray-600 mb-4">
            {{ t('chooseProfile.playerDescription') }}
          </p>

          <!-- Display user email -->
          <div class="mt-6 p-3 bg-gray-100 border border-gray-300 rounded">
            <p class="text-xs text-gray-600 mb-1">{{ t('chooseProfile.yourEmail') }}</p>
            <p class="text-sm font-medium text-gray-900">{{ userEmail }}</p>
            <p class="text-xs text-gray-500 mt-2">{{ t('chooseProfile.shareEmail') }}</p>
          </div>
        </div>

        <!-- Right Side: Club/Organization -->
        <div class="bg-white border-2 border-gray-300 rounded shadow-md p-6">
          <h2 class="text-xl font-semibold text-gray-800 mb-3">{{ t('chooseProfile.clubTitle') }}</h2>
          <p class="text-sm text-gray-600 mb-6">
            {{ t('chooseProfile.clubDescription') }}
          </p>

          <!-- Register Club Button -->
          <router-link
            to="/register-club"
            class="block w-full py-3 px-4 bg-blue-600 text-white text-center font-medium rounded hover:bg-blue-700 transition"
          >
            {{ t('chooseProfile.registerClub') }}
          </router-link>

          <!-- Additional Info -->
          <div class="mt-4 p-3 bg-blue-50 border border-blue-200 rounded">
            <p class="text-xs text-blue-800">
              <strong>{{ t('chooseProfile.benefits') }}</strong> {{ t('chooseProfile.benefitsDescription') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
